module.exports = __webpack_public_path__ + "assets/img/jiebg.9047c726.png";